import { Module } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { AsideInfoItem } from './elements/AsideInfoItem'
import * as Styled from './styles'

interface AsideInfoProps {
  children: ReactNode
  className?: string
  isDense?: boolean
  title?: string
}

export const AsideInfo = ({ children, className, title, isDense }: AsideInfoProps): ReactElement => (
  <Styled.AsideInfoWrapper className={className} isDense={isDense}>
    <Module>
      <Module.Section title={title}>{children}</Module.Section>
    </Module>
  </Styled.AsideInfoWrapper>
)

AsideInfo.Item = AsideInfoItem
